import React from 'react'
import maps from '../Assets/maps.svg'

function GeographicPresence({ description, backgroundColor }) {
  return (
    <div
      className="flex-center padding-100 background-light"
      style={{ background: backgroundColor }}
    >
      <div className="flex-center flex__gap-50">
        <div data-aos="fade-up-right" className="flex-center half-screen">
          <div>
            <img src={maps} alt="Localização" />
          </div>
          <h2 className="title-main text-dark">Presença Geográfica</h2>
        </div>
        <p
          data-aos="fade-up-left"
          className="half-screen paragraph-default text-dark"
        >
          {description}
        </p>
      </div>
    </div>
  )
}

export default GeographicPresence
